import {
  formatRelativeTimestamp,
  formatRelativeTimestampWithTime,
} from "@/utils/formatting/format-timestamp"
import { stringifyUnknownValue } from "@/utils/stringifyUnknownValue"

interface TopLevelField {
  key: string
  value: string
}

export const getTopLevelFields = (
  value: unknown,
  limit?: number,
): TopLevelField[] => {
  if (!value) {
    return []
  }
  try {
    const parsed = (
      typeof value === "string" ? JSON.parse(value) : value
    ) as Record<string, unknown>
    const fields = Object.entries(parsed).map(([key, val]) => ({
      key,
      value:
        typeof val === "object"
          ? JSON.stringify(val)
          : stringifyUnknownValue(val),
    }))

    if (limit && fields.length > limit) {
      return fields.slice(0, limit)
    }

    return fields
  } catch {
    return []
  }
}

export const formatDateTime = (timestamp: string): string =>
  formatRelativeTimestamp(timestamp)

export const formatDateTimeWithTime = (timestamp: string): string =>
  formatRelativeTimestampWithTime(timestamp)
